import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
export const DriveTitle = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const CardRow = styled(Flex)`
  gap: 15px;
  margin: 15px 0 34px;
`
export const RolenameFlex = styled(Flex)`
  margin: 0 0 15px;
`
export const RoleInfoFlex = styled(Flex)`
  padding: 0 40px 0 0;
`
export const TitleDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  color: #999fac;
  font-size: 14px;
  margin: 10px 0px;
`
export const CountDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #4d566e;
`
export const RoleFlex = styled(Flex)`
  padding-right: 50px;


  border-right: ${props => !props?.border && `1px solid ${COLORS.GREY_T_90}`};
`
export const InterviewDiv = styled.div`
  padding: 1px 25px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  margin: 15px 0;
`
export const RoundInfoFlex = styled(Flex)`
  padding: 10px 0;
  border-bottom: ${props =>
    !props?.isboader && `1px solid ${COLORS.GREY_T_90}`};
`
export const RounNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
  flex: 0.4;
  margin: 8px 0;
  text-transform: capitalize;
`

export const ClickView = styled.div`
  cursor: pointer;
`

export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
